module.exports = __webpack_public_path__ + "static/cardImg02_02-60e506d961a83922a91680f5da22980b.png";